(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-cart-progress-bar"] && !Shopify.designMode) return;
  try {
    
  class CartProgressBar extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.c-cart-progress-bar__wrapper');
      if (!this.wrapper) return;
      
      this.threshold = parseInt(this.wrapper.dataset.threshold, 10);
      this.message = this.wrapper.dataset.message;
      this.completeMessage = this.wrapper.dataset.completeMessage;
      this.moneyFormat = this.wrapper.dataset.moneyFormat;
      
      this.textEl = this.wrapper.querySelector('.c-cart-progress-bar__text');
      this.fillEl = this.wrapper.querySelector('.c-cart-progress-bar__fill');
      this.iconEl = this.wrapper.querySelector('.c-cart-progress-bar__icon');
      this.iconProgressEl = this.wrapper.querySelector('.c-cart-progress-bar__icon-progress');
      this.iconCompleteEl = this.wrapper.querySelector('.c-cart-progress-bar__icon-complete');
      
      this.bindEvents();
    }
    
    bindEvents() {
      document.addEventListener('line-item:change:end', this.onCartUpdate.bind(this));
    }
    
    onCartUpdate(event) {
      const cart = event.detail?.cart;
      if (!cart) return;
      
      const total = cart.total_price;
      const itemCount = cart.item_count;
      
      // Show/hide based on item count
      if (itemCount === 0) {
        this.wrapper.style.display = 'none';
        return;
      } else {
        this.wrapper.style.display = '';
      }
      
      // Calculate progress
      let progressPercentage = (total / this.threshold) * 100;
      if (progressPercentage > 100) progressPercentage = 100;
      
      let remainingAmount = this.threshold - total;
      if (remainingAmount < 0) remainingAmount = 0;
      
      // Subscriptions always ship free, so any subscription line unlocks the bar
      const hasSubscription = (cart.items || []).some((item) => item.selling_plan_allocation);
      const isComplete = hasSubscription || total >= this.threshold;
      if (isComplete) progressPercentage = 100;
      
      // Update fill width
      this.fillEl.style.width = `${progressPercentage}%`;
      
      // Update text
      if (isComplete) {
        this.textEl.textContent = this.completeMessage;
        this.textEl.classList.add('c-cart-progress-bar__text--complete');
        this.wrapper.classList.add('c-cart-progress-bar__wrapper--complete');
        if (this.iconEl) {
          this.iconEl.classList.add('c-cart-progress-bar__icon--complete');
        }
        if (this.iconProgressEl) {
          this.iconProgressEl.style.display = 'none';
        }
        if (this.iconCompleteEl) {
          this.iconCompleteEl.style.display = '';
        }
      } else {
        const formattedAmount = this.formatMoney(remainingAmount, this.moneyFormat);
        this.textEl.textContent = this.message.replace('[amount]', formattedAmount);
        this.textEl.classList.remove('c-cart-progress-bar__text--complete');
        this.wrapper.classList.remove('c-cart-progress-bar__wrapper--complete');
        if (this.iconEl) {
          this.iconEl.classList.remove('c-cart-progress-bar__icon--complete');
        }
        if (this.iconProgressEl) {
          this.iconProgressEl.style.display = '';
        }
        if (this.iconCompleteEl) {
          this.iconCompleteEl.style.display = 'none';
        }
      }
      
      // Update data attribute
      this.wrapper.dataset.cartTotal = total;
    }
    
    formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '${{amount}}';
      
      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) return 0;
        
        number = (number / 100.0).toFixed(precision);
        
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';
        
        return dollarsAmount + centsAmount;
      }
      
      let value = '';
      switch (formatString.match(placeholderRegex)?.[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      
      return formatString.replace(placeholderRegex, value);
    }
  }
  
  customElements.define('cart-progress-bar', CartProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-dr-sowa-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dr-sowa-intro-player')) {
    customElements.define('dr-sowa-intro-player', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.c-dr-sowa-intro__play');
        this.errorMessage = this.querySelector('.c-dr-sowa-intro__video-error');
        if (!this.video || !this.button) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.video.controls = false;
        this.button.hidden = false;
        this.button.disabled = false;
        this.updateState();
        this.button.addEventListener('click', () => {
          if (!this.video.paused) {
            this.video.pause();
            return;
          }
          this.errorMessage.hidden = true;
          this.button.disabled = true;
          this.video.play().catch((error) => {
            if (!this.isConnected || error.name === 'AbortError') return;
            this.showError(error);
          }).finally(() => {
            this.button.disabled = false;
          });
        }, options);
        this.video.addEventListener('playing', () => this.updateState(), options);
        this.video.addEventListener('pause', () => this.updateState(), options);
        this.video.addEventListener('ended', () => this.updateState(), options);
        this.video.addEventListener('error', () => this.showError(this.video.error), options);
      }

      updateState() {
        const playing = !this.video.paused && !this.video.ended;
        this.dataset.state = playing ? 'playing' : 'idle';
        this.button.setAttribute('aria-pressed', String(playing));
        this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
      }

      showError(error) {
        console.error('Dr. Sowa intro video playback failed:', error);
        this.video.pause();
        this.updateState();
        this.errorMessage.hidden = false;
        this.button.disabled = false;
      }

      disconnectedCallback() {
        this.events?.abort();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.c-product-atc');

    sections.forEach(function (section) {
      var sectionEl = section.closest('[id]');
      if (!sectionEl) return;

      /* ---- Variant selector ---- */
      var variantBtns = sectionEl.querySelectorAll('.c-product-atc__variant-btn');
      var hiddenInput = sectionEl.querySelector('.product-variant-id');
      var priceEl = sectionEl.querySelector('[data-price]');
      var comparePriceEl = sectionEl.querySelector('[data-compare-price]');
      var submitBtn = sectionEl.querySelector('.c-product-atc__submit');

      variantBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          variantBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          if (hiddenInput) hiddenInput.value = btn.dataset.variantId;
          if (priceEl) priceEl.textContent = btn.dataset.variantPrice;

          if (comparePriceEl) {
            if (btn.dataset.variantComparePrice && btn.dataset.variantComparePrice !== btn.dataset.variantPrice) {
              comparePriceEl.textContent = btn.dataset.variantComparePrice;
              comparePriceEl.style.display = '';
            } else {
              comparePriceEl.style.display = 'none';
            }
          }

          if (submitBtn) {
            submitBtn.disabled = btn.disabled;
          }
        });
      });

      /* ---- Ajax ATC ---- */
      var form = sectionEl.querySelector('.c-product-atc__form');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitBtn) {
          submitBtn.classList.add('is-loading');
          submitBtn.disabled = true;
        }

        var formData = new FormData(form);
        formData.append('sections', 'main-cart,cart-drawer,cart-bubble');
        formData.append('sections_url', window.location.pathname);

        fetch(window.theme && window.theme.routes ? window.theme.routes.cart_add_url : '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status === 422) {
              console.error('ATC error:', response.description);
              if (submitBtn) {
                submitBtn.classList.remove('is-loading');
                submitBtn.disabled = false;
              }
              return;
            }

            var sections = response.sections;
            if (sections) {
              var parser = new DOMParser();

              /* Update cart drawer */
              var cartDrawerEl = document.getElementById('Cart-Drawer');
              if (cartDrawerEl && sections['cart-drawer']) {
                var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
                var newDrawer = drawerDoc.querySelector('.cart-drawer');
                if (newDrawer) cartDrawerEl.innerHTML = newDrawer.innerHTML;
              }

              /* Update cart bubble count */
              var cartBubble = document.querySelector('.thb-item-count');
              if (cartBubble && sections['cart-bubble']) {
                var bubbleDoc = parser.parseFromString(sections['cart-bubble'], 'text/html');
                var newBubble = bubbleDoc.querySelector('.thb-item-count');
                if (newBubble) cartBubble.innerHTML = newBubble.innerHTML;
              }
            }

            /* Re-init cart drawer */
            if (typeof window.CartDrawer === 'function') {
              window.cartDrawer = new window.CartDrawer();
            } else if (window.cartDrawer && typeof window.cartDrawer.reinit === 'function') {
              window.cartDrawer.reinit();
            }

            /* Open cart drawer */
            document.body.classList.add('open-cc', 'open-cart');
            var cartDrawer = document.getElementById('Cart-Drawer');
            if (cartDrawer) cartDrawer.classList.add('active');

            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart-drawer:open');
              dispatchCustomEvent('cart:item-added');
            }

            if (submitBtn) {
              submitBtn.classList.remove('is-loading');
              submitBtn.disabled = false;
            }
          })
          .catch(function (err) {
            console.error('ATC fetch error:', err);
            if (submitBtn) {
              submitBtn.classList.remove('is-loading');
              submitBtn.disabled = false;
            }
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-socialproof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-social-proof-review')) {
    customElements.define('c-social-proof-review', class extends HTMLElement {
      connectedCallback() {
        this.scheduleFit = () => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => this.fitText());
        };
        this.resizeObserver = new ResizeObserver(this.scheduleFit);
        this.resizeObserver.observe(this);
        document.fonts.addEventListener('loadingdone', this.scheduleFit);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleFit();
        });
        this.scheduleFit();
      }

      disconnectedCallback() {
        this.resizeObserver.disconnect();
        document.fonts.removeEventListener('loadingdone', this.scheduleFit);
        cancelAnimationFrame(this.fitFrame);
      }

      fitText() {
        const quote = this.querySelector('.social-proof__texts__description');
        const content = this.querySelector('.social-proof__texts__content');
        if (!quote || !content || !this.clientWidth || !this.clientHeight) return;

        // Start at the responsive size so shorter reviews keep their original type.
        quote.style.removeProperty('font-size');
        const styles = getComputedStyle(this);
        const availableHeight = this.clientHeight - parseFloat(styles.paddingTop) - parseFloat(styles.paddingBottom);
        const fits = () => content.getBoundingClientRect().height <= availableHeight
          && quote.scrollWidth <= quote.clientWidth;
        if (fits()) return;

        // Measure the whole content, including stars, author, badge and gaps.
        let lower = 0;
        let upper = parseFloat(getComputedStyle(quote).fontSize);
        while (upper - lower > 0.1) {
          const size = (lower + upper) / 2;
          quote.style.fontSize = `${size}px`;
          if (fits()) lower = size;
          else upper = size;
        }
        quote.style.fontSize = `${Math.floor(lower * 10) / 10}px`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-sowell-checkin"] && !Shopify.designMode) return;
  try {
    
/* SoWell weekly check-in. Answers remain in memory; no tracking or storage. */
(() => {
  if (customElements.get('sowell-checkin')) return;

  class SoWellCheckin extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.questions = [...this.querySelectorAll('[data-question]')];
      if (!this.questions.length) return;
      this.step = 0;
      this.form = this.querySelector('[data-quiz-form]');
      this.next = this.querySelector('[data-next]');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!this.selected(this.questions[this.step])) return;
        if (this.step === this.questions.length - 1) this.showResults();
        else this.showStep(this.step + 1);
      }, { signal });
      this.form.addEventListener('change', () => {
        this.next.disabled = !this.selected(this.questions[this.step]);
      }, { signal });
      this.querySelector('[data-back]').addEventListener('click', () => {
        this.showStep(Math.max(0, this.step - 1));
      }, { signal });
      this.querySelector('[data-restart]').addEventListener('click', () => {
        this.form.reset();
        this.querySelector('[data-results]').hidden = true;
        this.querySelector('[data-quiz-flow]').hidden = false;
        this.querySelector('[data-summary]').replaceChildren();
        this.showStep(0);
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.questions.findIndex((question) => question.dataset.question === event.detail.blockId);
        if (index < 0) return;
        this.querySelector('[data-results]').hidden = true;
        this.querySelector('[data-quiz-flow]').hidden = false;
        this.showStep(index, false);
      }, { signal });
      this.querySelector('[data-results]').hidden = true;
      this.querySelector('[data-quiz-flow]').hidden = false;
      this.querySelector('[data-quiz-card]').hidden = false;
      this.showStep(0, false);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    selected(question) {
      return question.querySelector('input:checked');
    }

    showStep(index, focus = true) {
      this.step = index;
      this.questions.forEach((question, i) => { question.hidden = i !== index; });
      this.querySelector('[data-step]').textContent = index + 1;
      this.querySelector('[data-progress]').value = index + 1;
      this.querySelector('[data-category]').textContent = this.questions[index].dataset.category;
      this.querySelector('[data-back]').hidden = index === 0;
      this.next.disabled = !this.selected(this.questions[index]);
      const text = index === this.questions.length - 1 ? '[data-finish-text]' : '[data-next-text]';
      this.querySelector('[data-next-label]').textContent = this.querySelector(text).content.textContent;
      if (focus) this.questions[index].querySelector('legend').focus();
    }

    showResults() {
      const resources = new Set();
      const tips = [];
      const summary = document.createDocumentFragment();
      for (const question of this.questions) {
        const answer = this.selected(question);
        if (!answer) {
          this.showStep(this.questions.indexOf(question));
          return;
        }
        answer.dataset.resources.split(',').filter(Boolean).forEach((key) => resources.add(key));
        if (answer.dataset.tip) tips.push(answer.dataset.tip);
        const title = document.createElement('dt');
        const value = document.createElement('dd');
        title.textContent = question.querySelector('legend').textContent;
        value.textContent = answer.closest('label').lastElementChild.textContent;
        summary.append(title, value);
      }
      this.querySelector('[data-summary]').replaceChildren(summary);
      this.querySelectorAll('[data-resource]').forEach((resource) => {
        resource.hidden = !resources.has(resource.dataset.resource);
      });
      this.querySelector('[data-tips]').replaceChildren(...tips.map((tip) => {
        const item = document.createElement('li');
        item.className = 'c-block-description c-checkin__tip';
        item.textContent = tip;
        return item;
      }));
      this.querySelector('[data-tip-section]').hidden = tips.length === 0;
      this.querySelector('[data-resource-section]').hidden = resources.size === 0;
      this.querySelector('[data-empty]').hidden = resources.size > 0 || tips.length > 0;
      this.querySelector('[data-quiz-flow]').hidden = true;
      this.querySelector('[data-results]').hidden = false;
      this.querySelector('[data-result-heading]').focus();
    }
  }
  customElements.define('sowell-checkin', SoWellCheckin);
})();

  } catch(e) { console.error(e); }
})();
})();
